import { render, staticRenderFns } from "./EditProductInStockLocationToggle.vue?vue&type=template&id=4cabd32d&scoped=true"
import script from "./EditProductInStockLocationToggle.vue?vue&type=script&lang=js"
export * from "./EditProductInStockLocationToggle.vue?vue&type=script&lang=js"
import style0 from "./EditProductInStockLocationToggle.vue?vue&type=style&index=0&id=4cabd32d&prod&lang=scss&scoped=true"
import style1 from "./EditProductInStockLocationToggle.vue?vue&type=style&index=1&id=4cabd32d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cabd32d",
  null
  
)

export default component.exports